var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#78C081"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.826 14.552-2.05-1.025-1.304-3.394a.31.31 0 0 0-.175-.178L8.202 6.719a.312.312 0 0 0-.336.068l-1.08 1.08a.312.312 0 0 0-.067.335l3.236 8.095a.311.311 0 0 0 .178.175l3.394 1.304 1.025 2.05a.312.312 0 0 0 .23.174.261.261 0 0 0 .05 0 .313.313 0 0 0 .22-.092l4.856-4.857a.313.313 0 0 0 .092-.27.313.313 0 0 0-.174-.23zM7.373 8.16l.174-.172 4.03 4.03a1.839 1.839 0 1 0 .442-.443l-4.03-4.03.172-.173 7.777 3.111 1.226 3.19-3.489 3.49-3.19-1.227-3.112-7.776zm5.705 3.703a1.214 1.214 0 1 1-.003 2.428 1.214 1.214 0 0 1 .003-2.428zm1.84 7.295-.782-1.562 3.458-3.458 1.562.781-4.239 4.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.977 16.719a.322.322 0 0 0-.443 0l-.397.397a8.58 8.58 0 0 1-.156-9.96 1.603 1.603 0 0 0 2.181-2.17 8.58 8.58 0 0 1 9.96.156l-.403.392a.312.312 0 0 0 0 .443l1.378 1.367a.312.312 0 0 0 .44 0l1.37-1.37a.311.311 0 0 0 0-.443l-1.37-1.37a.313.313 0 0 0-.44 0l-.53.526a9.205 9.205 0 0 0-9.234-1.073l1.801-1.797a.958.958 0 1 0-.447-.442L6.647 4.42A1.605 1.605 0 0 0 4.42 6.647l-3.045 3.04a.96.96 0 1 0 .442.443L3.62 8.333a9.205 9.205 0 0 0 1.068 9.234l-.528.53a.313.313 0 0 0 0 .44l1.37 1.37a.313.313 0 0 0 .443 0l1.372-1.37a.313.313 0 0 0 0-.44l-1.367-1.378zM18.32 4.82l.928.928-.928.929-.928-.929.928-.928zM10.312.723a.333.333 0 1 1 .473.469.333.333 0 0 1-.473-.469zm-5.25 4.34a.976.976 0 0 1 1.653.501.98.98 0 1 1-1.653-.502zM1.194 10.78a.333.333 0 0 1-.469-.469.334.334 0 0 1 .54.108.331.331 0 0 1-.071.361zm4.56 8.458-.927-.928.928-.928.928.928-.928.928z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.2f24e6ecfed7fc717b1702bd2cadf78e.svg";
export { ForwardRef as ReactComponent };